export const enum NextStepsAfterSignIn {
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  MISSING_REQUIRED_MEMBER_FIELDS = 'MISSING_REQUIRED_MEMBER_FIELDS',
}

export const STEP = 'step';
export const TEMP_PASSWORD = 'xxBProfCUB';
export const CHANGE_PASSWORD_SUCCESS = 'change_password_success';
export const LOCAL_STORAGE_KEYS = { REDIRECT_INFO: 'redirectInfo' };
export const DEFAULT_REDIRECT_URL = '/';

export const STORAGE = 'storage';
export const KONTENT_ITEM_CODENAME_ATTRIBUTE_KEY = 'kontentItemCodename';
export const CHAMPIONSHIP_PLAYER_KEY = 'championshipPlayer';
export const DEFAULT_VALUES_QUERY_KEY = 'default_values';
export const AUTH_TOKEN_KEY = 'auth_token';
export const AVAILABLE_CHAMPIONSHIPS_ATTRIBUTE_KEY = 'available_championships';

export const CURRENT_CHAMPIONSHIP_ID_KEY = 'currentChampionshipId';
export const CHAMPIONSHIP_CADDIE_LINKED_PLAYER_KEY =
  'championshipCaddie_championshipPlayer';
export const CHAMPIONSHIP_CADDIE_GUID_KEY = 'championshipCaddie_id';
export const ACCREDITATION_FORM_KONTENT_ITEM_CODENAME =
  'accreditationFormKontentItemCodename';

export const REDIRECT_URI = 'redirect_uri';
